export enum BussinesTripMarkerStateEnum {
    none = 0,
    selected = 1,
    success = 2,
    failed = 3,
}

export class BussinesTripMarkerModel {
    public name: string = undefined;
    public interactive: boolean = true;
    public state: BussinesTripMarkerStateEnum =
        BussinesTripMarkerStateEnum.none;

    constructor(name: string) {
        this.name = name;
    }
}
